/**
 * @Author：zsj
 * @Date：2022/03/08
 */
import { combineReducers } from 'redux';
import homeReducer from './home';

const cReducer = combineReducers({
    home: homeReducer,
});

export default cReducer;
